import { render, staticRenderFns } from "./TagsManaging.vue?vue&type=template&id=50bdc73a&"
import script from "./TagsManaging.vue?vue&type=script&lang=js&"
export * from "./TagsManaging.vue?vue&type=script&lang=js&"
import style0 from "./TagsManaging.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports